import React from 'react';
import { useScreenInit } from '../useScreenInit.js';
import { ContentLibrary } from '../components/ContentLibrary';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { MetaPixel } from '../components/MetaPixel';
import { Offers } from '../components/Offers';
import { CostAndFinalCTA, GuaranteeAndFAQ, PainSection, PurchaseNotification, Testimonials } from '../components/SalesSections';
export function LandingPage() {
  useScreenInit();
  return <div className="min-h-screen w-full overflow-x-hidden bg-[#F8F7FB] font-sans text-[#24212A]" data-id="element-148" data-mp="26297npwnmjxr">
      <MetaPixel data-id="element-149" data-mp="2kz09s6xpq9r2" />
      <Hero data-id="element-150" data-mp="2kxfeug7hkoso" />
      <main data-id="element-151" data-mp="2ky8e6w448c0s">
        <section className="border-y border-[#DDD7E6] bg-[#F0ECF6] px-5 py-5 sm:px-8" data-id="element-152" data-mp="2kwnuk1jcadhp">
          <div className="mx-auto grid max-w-6xl grid-cols-3 gap-3 text-center text-[10px] font-bold uppercase tracking-[.08em] text-[#514B5A] sm:text-xs" data-id="element-153" data-mp="2g06y8k1zkstj">
            <p data-id="element-154" data-mp="lm5v3mzeljnn">
              <strong className="block font-serif text-2xl text-[#6D28D9] sm:text-3xl" data-id="element-155" data-mp="lmo13bbvbc8r">
                +500
              </strong>
              terapeutas confían
            </p>
            <p data-id="element-156" data-mp="33k0o224qxa07">
              <strong className="block font-serif text-2xl text-[#6D28D9] sm:text-3xl" data-id="element-157" data-mp="33lk2roar7czv">
                6
              </strong>
              tomos listos
            </p>
            <p data-id="element-158" data-mp="3da22013dxc1e">
              <strong className="block font-serif text-2xl text-[#6D28D9] sm:text-3xl" data-id="element-159" data-mp="3dalh7a1nhmbq">
                4.9/5
              </strong>
              calificación
            </p>
          </div>
        </section>
        <Testimonials data-id="element-160" data-mp="3n7ggvw9ntsrl" />
        <PainSection data-id="element-161" data-mp="3n6yba913y270" />
        <ContentLibrary data-id="element-162" data-mp="3nacetklichg1" />
        <Offers data-id="element-163" data-mp="3racut9o990p7" />
        <Testimonials data-id="element-164" data-mp="3r9uzcf9f2qic" />
        <GuaranteeAndFAQ data-id="element-165" data-mp="3ramk0v1h73tu" />
        <CostAndFinalCTA data-id="element-166" data-mp="3r8a40nfa33jf" />
      </main>
      <Footer data-id="element-167" data-mp="41x9nigei2m" />
      <PurchaseNotification data-id="element-168" data-mp="2qu9pwu1eck" />
    </div>;
}